/**
 * This method takes any value and if typeof is string will return to lower case, otherwise empty string.
 * Optional parameter to mutate value to string or return original value
 * @param value
 * @param mutateValue
 */

export default (value: any, mutateValue?: boolean): any => {
  if (typeof value === 'string') {
    return value?.toLowerCase();
  }
  
  return mutateValue ? '' : value;
};
